import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

/**
 * interfaces
 */
import { IResponse } from '@network';
import {
    IUnitTypeDto,
    IUnitTypeDetailsDto,
    ICreateUnitTypePayload,
    IUpdateUnitTypePayload,
} from '../../interfaces';

/**
 * constants
 */
import { UnitTypesConst } from '../../consts';

/**
 * HTTP layer for the Unit Types API endpoints.
 */
@Injectable()
export class UnitTypeApiService {

    /**
     * 
     * @param _http 
     */
    constructor(private readonly _http: HttpClient) {}

    /** Fetch all unit types. */
    public getList(): Observable<IResponse<IUnitTypeDto[]>> {
        return this._http.get<IResponse<IUnitTypeDto[]>>(UnitTypesConst.LIST_ENDPOINT);
    }

    /** Fetch a single unit type by ID. */
    public getById(id: string): Observable<IResponse<IUnitTypeDetailsDto>> {
        return this._http.get<IResponse<IUnitTypeDetailsDto>>(UnitTypesConst.GET_BY_ID_ENDPOINT(id));
    }

    /** Create a new unit type. */
    public create(payload: ICreateUnitTypePayload): Observable<IResponse<string>> {
        return this._http.post<IResponse<string>>(UnitTypesConst.CREATE_ENDPOINT, payload);
    }

    /** Update a unit type by ID. */
    public update(id: string, payload: IUpdateUnitTypePayload): Observable<IResponse<string>> {
        return this._http.put<IResponse<string>>(UnitTypesConst.UPDATE_ENDPOINT(id), payload);
    }

    /** Delete a unit type by ID. */
    public delete(id: string): Observable<IResponse<string>> {
        return this._http.delete<IResponse<string>>(UnitTypesConst.DELETE_ENDPOINT(id));
    }

}
